export default {
    methods: {
        formResultData(result) {
            return [
                ...result.samples.map(({ id, depth, analyses }) => {
                    return {
                        id, depth,
                        ...this.formatData(analyses)
                    };
                })
            ];
        },
        formatLabGuidelines(data) {
            return [
                ...data.guidelines.map(({ crop, crop_yield, units, results }) => {
                    return {
                        crop, crop_yield, units,
                        //...this.formatData(results)
                    }
                })
            ];
        },
        formatData(data) {
            return data.reduce((acc, curr) => {
                return {
                    ...acc,
                    [curr.name]: curr.result
                };
            }, {});
        },
    }
}